import { Injectable } from '@angular/core';
import { SharedEventNameEnum } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventNameEnum';
import { CustomFieldTypeEnum } from '@smarttask-common/src/lib/models/CustomField/Enums/CustomFieldTypeEnum';
import { OrganizationHubBase } from './organizationHubBase';

@Injectable({
    providedIn: 'root',
})
export class CustomFieldHubService extends OrganizationHubBase {
    protected subscribe_event = SharedEventNameEnum.custom_field_subscribe;
    protected unsubscribe_event = SharedEventNameEnum.custom_field_unsubscribe;

    constructor() {
        super();
        this.init();
    }

    protected registerHandlers = () => {
        this.on(SharedEventNameEnum.custom_field_create, (custom_field_id: string) => {
            this.broadcast(SharedEventNameEnum.custom_field_create, { custom_field_id });
        });

        this.on(SharedEventNameEnum.custom_field_update, (custom_field_id: string) => {
            this.broadcast(SharedEventNameEnum.custom_field_update, { custom_field_id });
        });

        this.on(SharedEventNameEnum.custom_field_type_update, (custom_field_id: string, new_type: CustomFieldTypeEnum) => {
            this.broadcast(SharedEventNameEnum.custom_field_type_update, { custom_field_id, new_type });
        });

        this.on(SharedEventNameEnum.custom_field_delete, (custom_field_id: string) => {
            this.broadcast(SharedEventNameEnum.custom_field_delete, { custom_field_id });
        });

        this.on(SharedEventNameEnum.custom_field_project_create, (custom_field_id: string, project_id: string) => {
            this.broadcast(SharedEventNameEnum.custom_field_project_create, { project_id, custom_field_id });
        });

        this.on(SharedEventNameEnum.custom_field_project_delete, (custom_field_id: string, project_id: string) => {
            this.broadcast(SharedEventNameEnum.custom_field_project_delete, { project_id, custom_field_id });
        });
    };
}
